import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Inject, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "../../../services/dialog.service";
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "cota-error",
  templateUrl: "./cota-error.component.html",
  styleUrls: ["./cota-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class CotaErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ngOnInit(): void {}

  ColumnsQuota: string[] = [
    "operationTypeId",
    "settlementTypeId",
    "portfolioName",
    "portfolioDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioCetipAccount",
    "isSecondaryMarket",
    "isIssueUnitPrice",
    "operationValue",
    "amount",
    "quotaValue",
    "subscriptionDate",
    "isNewFund",
    "fundDocument",
    "fundName",
    "fundAdministrator",
    "fundBank",
    "fundBranch",
    "fundAccount",
    "mnemonicCode",
    "quotationDate",
    "settlementDate",
    "fundType",
    "fundClass",
    "fundSeries",
    "fundSeriesQuantity",
    "isNewCounterpart",
    "counterpartName",
    "counterpartDocument",
    "counterpartBank",
    "counterpartBranch",
    "counterpartAccount",
    "annotations",
  ];
}
